import { c as _c } from "react/compiler-runtime";
import { DEFAULT_IMAGE } from '@/app/components/media/image/constants';
import { getImageQueryParams, getMediaCondition, getSourceSrcset } from '@/app/components/media/image/utils';
import { getSplashImageSources } from '@/app/components/splash/image-sources';
import { SPLASH_DATA_TEST } from '@/app/components/splash/tracking';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import type { SplashPopup } from '@/services/splash/types';
export interface SplashImageProps {
  splash: SplashPopup;
  loadImageImmediately: boolean;
}
export const SplashImage = t0 => {
  const $ = _c(18);
  const {
    splash,
    loadImageImmediately
  } = t0;
  let src;
  let t1;
  let t2;
  let t3;
  if ($[0] !== loadImageImmediately || $[1] !== splash) {
    const sources = loadImageImmediately ? getSplashImageSources(splash) : [];
    let t4;
    if ($[6] !== loadImageImmediately || $[7] !== splash.imageDesktop) {
      t4 = loadImageImmediately ? getImageQueryParams(splash.imageDesktop.url, {}, "sources") : DEFAULT_IMAGE;
      $[6] = loadImageImmediately;
      $[7] = splash.imageDesktop;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    src = t4;
    t1 = "absolute inset-0 block overflow-hidden";
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = createDataAttributes({
        test: SPLASH_DATA_TEST.image
      });
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    t3 = sources.map(_temp);
    $[0] = loadImageImmediately;
    $[1] = splash;
    $[2] = src;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    src = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[10] !== splash.title || $[11] !== src) {
    t4 = <img src={src} alt={splash.title} width={296} height={395} className="is-loaded size-full max-h-full min-h-full min-w-full object-cover" />;
    $[10] = splash.title;
    $[11] = src;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = <picture className={t1} {...t2}>{t3}{t4}</picture>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};
function _temp(source, index) {
  return <source key={index} srcSet={getSourceSrcset(source)} media={getMediaCondition(source) || undefined} />;
}